import loadable from '@loadable/component';

export const AuthMfaPageLoadable = loadable(() => import('./AuthMfaPage'), {
  resolveComponent: (module) => module.AuthMfaPage,
});
